import { KnobIcon } from './KnobIcon';

/**
 * author: Michael Irigoyen
 * id BF72875E-F657-4469-B7B6-CC8116EC20D1
 * name knob
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/knob.svg
 * tags
 * - Audio 
 */
export const VolumeKnobIcon = KnobIcon;
export default VolumeKnobIcon